/* VF: show the category cover photos on Convermax category tiles and on the
   homepage "Shop by category" cards. See snippets/vf_category-covers.liquid
   for why. Convermax re-renders its tiles whenever the vehicle or the results
   change, so this re-applies on DOM changes. Tiles are matched by the
   collection handle in their link (the link may carry ?Year/.../Make/...
   after the handle). Swapped tiles get .vf-cat-photo for the dark card CSS. */
(function () {
  'use strict';
  var covers = window.VF_CATEGORY_COVERS || {};
  if (!Object.keys(covers).length) return;

  function handleOf(href) {
    var m = /\/collections\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function swap(tile, link) {
    var url = covers[handleOf(link.getAttribute('href'))];
    if (!url) return;
    var img = tile.querySelector('img');
    if (!img) return;
    tile.classList.add('vf-cat-photo');
    if (img.getAttribute('data-vf-cover') === url) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
    img.setAttribute('data-vf-cover', url);
  }

  /* A category whose collection is unpublished (Body Armor, Bumpers/Grilles/
     Guards) still shows up while Convermax's index holds a few of its
     products. Convermax then links the tile to /pages/search?category/...
     instead of /collections/, with the raw product photo. No collection page
     means the category is retired: hide the tile. */
  function hideRetired() {
    var stray = document.querySelectorAll('.cm_vehicle-categories_category-wrapper a[href*="/pages/search?category"]');
    for (var i = 0; i < stray.length; i++) {
      var wrap = stray[i].closest('.cm_vehicle-categories_category-wrapper');
      if (wrap && wrap.style.display !== 'none') wrap.style.display = 'none';
    }
  }

  function apply() {
    hideRetired();
    var tiles = document.querySelectorAll('a.cm_vehicle-categories_link[href*="/collections/"], .cm_vehicle-categories a[href*="/collections/"]');
    for (var i = 0; i < tiles.length; i++) swap(tiles[i], tiles[i]);
    var cards = document.querySelectorAll('.collection-card');
    for (var j = 0; j < cards.length; j++) {
      var link = cards[j].querySelector('a.collection-card__link[href*="/collections/"]');
      if (link) swap(cards[j], link);
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }

  apply();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
